import { Expose } from "class-transformer";
import { UserHasQualificationStatusEnum } from "@altertec_gparn/lib";

export class UpdateUserHasQualificationStatusBulkDto {
  @Expose()
  ids: string[];

  @Expose()
  status: UserHasQualificationStatusEnum;
}
